<template>
  <v-container>
    <v-avatar :size="zoom * 200" class="overflow-hidden">
      <div
        class="draggable-container"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
        @touchstart="startTouch"
        @touchmove="onTouchMove"
        @touchend="stopDrag"
      >
        <img
         :src="server_url +'api/principal/get_image/'+principal.identificador+'/'+principal.linkPhoto"
          :style="imageStyle"
          ref="image"
        />
      </div>
    </v-avatar>

    <v-card-text>
      <v-slider
        v-model="principal.zoom"
        min="0.5"
        max="3"
        step="0.1"
        append-icon="mdi-magnify-plus-outline"
        prepend-icon="mdi-magnify-minus-outline"
        @click:append="zoomIn"
        @click:prepend="zoomOut"
        @input="onZoomChange"
      ></v-slider>
      <p>Zoom: {{ principal.zoom }}</p>
      <p>Offset X: {{ principal.offsetX }}</p>
      <p>Offset Y: {{ principal.offsetY }}</p>
    </v-card-text>
  </v-container>
</template>

<script>



import { http } from "@/services/config";


export default {
  data() {
    return {
          server_url: "",
      principal: {
        zoom: 1,
        offsetX: 0,
        offsetY: 0,
      },
      dragging: false,
      dragStartX: 0,
      dragStartY: 0,
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/PNG_transparency_demonstration_1.png/640px-PNG_transparency_demonstration_1.png",
    };
  },
  mounted(){

    
     this.server_url = http.defaults.baseURL;

  },
  computed: {
    zoom() {
      return this.principal.zoom;
    },
    imageStyle() {
      return {
        transform: `scale(${this.zoom}) translate(${this.principal.offsetX / this.zoom}px, ${this.principal.offsetY / this.zoom}px)`,
        transformOrigin: "top left",
        cursor: this.dragging ? "grabbing" : "grab",
        userSelect: "none",
        position: "absolute",
        top: "0",
        left: "0",
        maxWidth: "none",
        maxHeight: "none",
      };
    },
  },
  methods: {
    zoomIn() {
      this.principal.zoom = Math.min(this.principal.zoom + 0.1, 3);
    },
    zoomOut() {
      this.principal.zoom = Math.max(this.principal.zoom - 0.1, 0.5);
    },
    onZoomChange(value) {
      this.principal.zoom = value;
    },
    startDrag(event) {
      this.dragging = true;
      this.dragStartX = event.clientX - this.principal.offsetX;
      this.dragStartY = event.clientY - this.principal.offsetY;
    },
    onDrag(event) {
      if (this.dragging) {
        this.principal.offsetX = event.clientX - this.dragStartX;
        this.principal.offsetY = event.clientY - this.dragStartY;
      }
    },
    stopDrag() {
      this.dragging = false;
    },
    // 📱 Soporte para móviles
    startTouch(event) {
      if (event.touches.length === 1) {
        this.dragging = true;
        const touch = event.touches[0];
        this.dragStartX = touch.clientX - this.principal.offsetX;
        this.dragStartY = touch.clientY - this.principal.offsetY;
      }
    },
    onTouchMove(event) {
      if (this.dragging && event.touches.length === 1) {
        const touch = event.touches[0];
        this.principal.offsetX = touch.clientX - this.dragStartX;
        this.principal.offsetY = touch.clientY - this.dragStartY;
      }
    },
  },
};
</script>

<style scoped>
.draggable-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  touch-action: none; /* Impide que el navegador interrumpa el gesto */
}
</style>
